import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { MentorTip } from "../../../components";
import type { Navigation } from "../../../models/navigation";
import { TabsLayout } from "../../../shared/components";
import { Goal } from "../../../shared/components/goal";
import { Header } from "../../../shared/components/header";
import { MonthlyActivity } from "../../../shared/components/monthly-activity/monthly-activity.component";
import { Streak } from "../../../shared/components/streak";
import { useBffLearning, useInIframe } from "../../../shared/hooks";
import { useHistory } from "../../../shared/hooks/useHistory";
import { LearningTab } from "../learning-tab";
import { useStyles } from "./learningContainer.styles";
import { tabsContent } from "./tabs.const";

interface LearningContainerProps {
  navigation: Navigation[];
}

export const LearningContainer = ({ navigation }: LearningContainerProps) => {
  const classes = useStyles();
  const isInIframe = useInIframe();
  const history = useHistory();
  const { data, isFetching } = useBffLearning();

  if (isFetching) {
    return (
      <Grid className={classes.loading}>
        <CircularProgress />
      </Grid>
    );
  }

  const handleCallToActionClick = () => {
    history.push("/learningPath");
  };

  return (
    <Header navigation={navigation}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={6}>
            <Grid item md={8} xl={9}>
              {isInIframe ? (
                <LearningTab
                  learningPath={data.currentLearningPath}
                  course={data.activeCourse}
                />
              ) : (
                <TabsLayout
                  variant="new"
                  title="Learning"
                  listComponents={tabsContent.map((tab) => ({
                    id: tab.id,
                    slug: tab.slug,
                    label: (
                      <span className={classes.tabItemContainer}>
                        <div className={classes.tabIcon}>{tab.icon}</div>
                        <Typography className={classes.tabTitle}>
                          {tab.title}
                        </Typography>
                      </span>
                    ),
                    component: tab.component({
                      learningPath: data.currentLearningPath,
                      course: data.activeCourse,
                    }),
                  }))}
                />
              )}
            </Grid>
            <Grid item md={4} xl={3}>
              <Goal
                id="learningGoal"
                goalIconClass={classes.goalIconClass}
                editIconClass={classes.editIconClass}
                columnGap={10}
              />
              <MentorTip
                className={classes.mentorTip}
                title={<Typography>Your goal is your North Star</Typography>}
                details={
                  <Typography>
                    It will keep you on path through your learning path!
                  </Typography>
                }
              />
              <Streak
                streakDates={data.activeDates}
                onClick={handleCallToActionClick}
              />
              <MonthlyActivity
                activityDates={data.activeDates}
                onKeepLearningClicked={handleCallToActionClick}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Header>
  );
};
